import { z } from '@fiverr-private/forms';
import { EMAIL_REGEX, FIVERR_ALLOWED_SUFFIX, FIVERR_DOMAIN } from '../../constants';
import { appTranslate } from '../../i18n';

export const createSchema = () =>
    z.object({
        email: z
            .string()
            .email({ message: appTranslate<string>('errors.validation.email.incomplete') })
            .regex(EMAIL_REGEX, { message: appTranslate<string>('errors.validation.email.incomplete') })
            .refine(
                (email) =>
                    email.endsWith(FIVERR_DOMAIN) || email.includes(FIVERR_ALLOWED_SUFFIX) || !email.includes('+'),
                {
                    message: appTranslate<string>('errors.validation.email.format'),
                }
            ),
    });

export type FormSchema = z.infer<ReturnType<typeof createSchema>>;
